module.exports = __webpack_public_path__ + "img/bs_logo_fr.c884086b.png";